/** Drawer slide + backdrop timing — keep enter/exit in sync to avoid jerk. */
export const FORM_DRAWER_TRANSITION_MS = {
  enter: 350,
  exit: 280,
};

/** Material-style easing: decelerate in, accelerate out. */
export const FORM_DRAWER_TRANSITION_EASING = {
  enter: 'cubic-bezier(0.0, 0, 0.2, 1)',
  exit: 'cubic-bezier(0.4, 0, 1, 1)',
};

export const FORM_DRAWER_TRANSITION_INSTANT = {
  enter: 0,
  exit: 0,
};

export function getFormDrawerTransitionConfig(prefersReducedMotion = false) {
  if (prefersReducedMotion) {
    return {
      duration: FORM_DRAWER_TRANSITION_INSTANT,
      easing: { enter: 'linear', exit: 'linear' },
      backdropDuration: 0,
    };
  }

  return {
    duration: FORM_DRAWER_TRANSITION_MS,
    easing: FORM_DRAWER_TRANSITION_EASING,
    backdropDuration: FORM_DRAWER_TRANSITION_MS.enter,
  };
}
